import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../firebase/credenciales';
import Swal from 'sweetalert2';
import './States.css';

const States = () => {
    const [stateData, setStateData] = useState([]);
    const [stateName, setStateName] = useState('');
    const navigate = useNavigate();

    const handleWheel = (e) => {
        if (e.target.type === 'number') {
            e.preventDefault();
        }
    };

    React.useEffect(() => {
        window.addEventListener('wheel', handleWheel, { passive: false });
        return () => {
            window.removeEventListener('wheel', handleWheel);
        };
    }, []);

    const handleAddState = async (e) => {
        e.preventDefault();

        if (stateName) {
            const newState = {
                name: stateName,
            };

            try {
                await addDoc(collection(db, 'Estados'), newState);
                setStateData([...stateData, newState]);
                Swal.fire({
                    title: 'Éxito',
                    text: 'Estado registrado con éxito.',
                });
                setStateName('');
                navigate('/admin/estados/settings');
            } catch (error) {
                console.error('Error al guardar el estado en la base de datos:', error);
                Swal.fire({
                    title: 'Error',
                    text: 'Ocurrió un error al guardar el estado en la base de datos.',
                });
            }
        } else {
            Swal.fire({
                title: 'Error',
                text: 'Por favor, llena todos los campos.',
            });
        }
    };

    return (
        <div className="states-container">
            <h1 className="states-title">Registrar Estados</h1>
            <form className="form-states" onSubmit={handleAddState}>
                <div className="input-row-states">
                    <label className="label-states">
                        Nombre del estado
                        <input
                            className="input-states"
                            type="text"
                            value={stateName}
                            onChange={(e) => setStateName(e.target.value)}
                            required
                        />
                    </label>
                </div>
                <div className="states-btn-container">
                    <button className="btn-sates" type="submit">Agregar estado</button>
                    <button className="btn-sates" onClick={() => navigate('/admin/estados/settings')}>Cancelar</button>
                </div>
            </form>
        </div>
    );
};

export default States;